const pad = (num, size) => {
  const s = '0' + num
  return s.substr(s.length - size)
}

export default pad
